import ProductCreateBlock from "./product-create-block";

export default ProductCreateBlock;